export default __webpack_public_path__ + "d0fa3bb2b7c9063dc59428c0d71fdf40.woff";